import RxOp from 'rxjs-operators';
import { useObservable } from 'react-use-observable';
import { useHistory, useLocation } from 'react-router-dom';
import React, {
  ChangeEvent, useMemo,
  useState,
  useRef
} from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';

import Toolbar from 'components/Layout/Toolbar';
import dashboardService from 'services/dashboard';
import selectedVentureService from 'services/profile';
import CardGraphs from '../Component/Card';
import VentureSelection from '../Component/VentureSelection';
import HistoricVentureStatus from '../Graphs/HistoricVentureStatus';
import VentureStatus from '../Graphs/StatusesBar';
import {
  allowedGraphStatuses,
  IVentureHistoryMetrics,
  IVentureStatusMetrics,
} from 'interfaces/dashboard';
import SnapshotPicker from '../Component/SnapshotPicker';

const ViewEntity = () => {
  const history = useHistory();
  const { search } = useLocation();
  const [ventureFilter, setVentureFilter] = useState<number[]>([]);
  const containerToPrint = useRef();

  const [loadingVenturesStatus, setLoadingVenturesStatus] = useState(true);
  const [loadingHistoryVentureStatus, setLoadingHistoryVentureStatus] =
    useState(true);

  const queryParams = useMemo(() => new URLSearchParams(search), [search]);

  const handleDashboardVenture = (ventureId: number, name: string) => () => {
    selectedVentureService
      .setProfile({ id: Number(ventureId), name })
      .pipe(RxOp.logError())
      .subscribe((res) => {
        history.push(
          `/documentation/dashboard/venture/${ventureId}?${queryParams}`
        );
      });
  };

  /*   const [totalsByStatus] = useObservable<IStatusMetrics[]>(() => {
      return dashboardService.getTotalsByStatus().pipe(
        RxOp.logError(),
      );
    }, []); */

  const [venturesStatus] = useObservable<IVentureStatusMetrics[]>(() => {
    setLoadingVenturesStatus(true);
    return dashboardService.getVenturesStatuses(queryParams).pipe(
      RxOp.logError(),
      RxOp.map((data) =>
        ventureFilter
          ? data.filter((i) => ventureFilter.includes(i.ventureId))
          : data
      ),
      RxOp.tap(() => {
        setLoadingVenturesStatus(false);
      })
    );
  }, [ventureFilter, queryParams]);

  const [historyVentureStatus] = useObservable<IVentureHistoryMetrics>(() => {
    setLoadingHistoryVentureStatus(true);
    return dashboardService.getVenturesHistory(queryParams).pipe(
      RxOp.logError(),
      RxOp.map((data) => {
        const ventures = ventureFilter
          ? data.ventures.filter((i) => ventureFilter.includes(i.id))
          : data.ventures;
        return { ...data, ventures };
      }),
      RxOp.tap(() => {
        setLoadingHistoryVentureStatus(false);
      })
    );
  }, [ventureFilter, queryParams]);

  const handleFilterVenure = (event: ChangeEvent<{ value: number[] }>) => {
    const { value } = event.target;
    setVentureFilter(value);
  };

  return (
    <>
      <Toolbar
        title="Dashboard"
        breadcrumbs={[{ title: 'Dashboard', href: '/documentation/dashboard' }]}
        containerToPrint={containerToPrint}
        hideVentureSelect
      />
      <Container innerRef={containerToPrint} style={{ marginTop: '35px' }}>
        <Card>
          <CardContent>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              style={{ marginBottom: 16 }}
            >
              <Grid item xs={12} lg={3}>
                <Typography
                  variant="h6"
                  color="primary"
                  style={{ fontWeight: 700 }}
                >
                  Empreendimentos
                </Typography>
              </Grid>

              <Grid item xs={12} sm={3} md={4} lg={3}>
                <SnapshotPicker />
              </Grid>

              <Grid item xs={12} sm={9} md={8} lg={6}>
                <VentureSelection
                  onChange={handleFilterVenure}
                  value={ventureFilter}
                />
              </Grid>
              <Grid item xs={12}>
                {(loadingVenturesStatus || loadingHistoryVentureStatus) && (
                  <LinearProgress color="secondary" />
                )}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {venturesStatus && (
                <CardGraphs bgcolor="#161d42">
                  <Grid container spacing={2}>
                    {venturesStatus
                      .sort((a, b) => a.ventureId - b.ventureId)
                      .map((ds, index) => (
                        <Grid
                          item
                          key={`document-status-graph-${ds.ventureId}-${index}`}
                          xs={12}
                          sm={4}
                        >
                          <VentureStatus
                            metrics={ds.statusByVenture.filter((sv) =>
                              allowedGraphStatuses.includes(sv.status)
                            )}
                            label={ds.ventureName}
                            onClick={handleDashboardVenture(
                              ds.ventureId,
                              ds.ventureName
                            )}
                          />
                        </Grid>
                      ))}
                  </Grid>
                </CardGraphs>
              )}
            </Grid>
            {historyVentureStatus && (
              <Grid item xs={12}>
                <HistoricVentureStatus metrics={historyVentureStatus} />
              </Grid>
            )}
          </CardContent>
        </Card>
      </Container>
    </>
  );
};
export default ViewEntity;
